module.exports = __webpack_public_path__ + "img/homepage-banner-members-paron-v2.05fd6fb5.jpg";